import React, { useEffect, useRef } from "react";
import { Col, Container, Row } from "react-bootstrap";
import Button from "react-bootstrap/Button";
import card from "../../assets/img/card-vegzelma.png";
import DownloadPDF from "../../utilities/pdfDownloader";
import cardyuflyma from "../../assets/img/card-yuflyma.png";
import bevacizumab from "../../assets/img/Color_bevacizumab_adcdHigh.png";
import cardadalimumab from "../../assets/img/card-adalimumab.png";
import { useParams, useSearchParams } from "react-router-dom";
import yuflymaLogo from "../../assets/img/yuflyma-logo.png";
import zymfentraLogo from "../../assets/img/Zymfentra_brand.png";
import adalimumabLogo from "../../assets/img/Adalimumab-aaty_logo.png";
import cardzymfentra from "../../assets/img/card-zymfentra-group.png";
import cardsteqeyma from "../../assets/img/card-steqeyma.png";
import cardstoboclo from "../../assets/img/card-stoboclo.png";
import cardosenvelt from "../../assets/img/card-osenvelt.png";
import cardavtozma from "../../assets/img/card-avtozma.png";

const Pharma = (props) => {
  let cardID = localStorage.getItem("cardID");
  const [searchParams] = useSearchParams();
  const { category } = useParams();
  const isFirstRender = useRef(false);
  const isZymfentra = category === "zymfentra";

  const isPaySign =
    category === "steqeyma" ||
    category === "zymfentra" ||
    category === "stoboclo" ||
    category === "osenvelt"||
    category === "avtozma"||
    category === "adalimumab" ||
    category === "vegzelma";

  useEffect(() => {
    const fetchAndDownloadPDF = async () => {
       if (isFirstRender.current) {
        const downloadFile = searchParams.get("downloadPDF");
        if (downloadFile === "true") {
          await DownloadPDF("root", "Instructions.pdf");
          setTimeout(() => {
            window.close();
          }, 500);
        }
      }
      isFirstRender.current = true;
    };

    fetchAndDownloadPDF();
  }, [searchParams]);

  let spanClass =
    isZymfentra || category === "adalimumab"
      ? "rselection roles-section3"
      : "rselection roles-section2";

  const categoryCardClasses = {
    yuflyma: "spanYuflyma download",
    zymfentra: "spanZymfentra",
    adalimumab: "spanAdalimumab download",
    vegzelma: "spanVegzelma-download",
    steqeyma: "spanSteqeyma",
    osenvelt: "spanOsenvelt download",
    stoboclo: "spanStoboclo download",
    avtozma: "spanStoboclo download",
  };

  return (
    <>
      <section className={spanClass}>
        {category === "yuflyma" ? (
          <img src={yuflymaLogo} className="bevacizumab" />
        ) : category === "vegzelma" ? (
          <img src={bevacizumab} className="bevacizumab" />
        ) : category === "zymfentra" ? (
          <img src={zymfentraLogo} className="bevacizumab" />
        ) : category === "adalimumab" ? (
          <img src={adalimumabLogo} className="bevacizumab" />
        ) : null}
        <Container>
          <Row>
            <Col>
              <div className="rselection-wrap role-wrap firstCard firstCardDownload">
                <div className="heads-icon">
                  <div className="all-set">
                    <p className="mainText mt1">You’re all set!</p>
                    <p className="mainText mt2">
                      Congratulations! Your enrollment in the Celltrion CARES
                      <sup className="reg">&reg;</sup> Co-pay Assistance Program
                      is complete!
                    </p>
                  </div>
                </div>
                <div className="text-center">
                  <p className="text-center title-saving mainText">
                    Co-pay Savings Card Information
                  </p>
                  <div className="card-wrapper d-block">
                    {category === "yuflyma" ? (
                      <img src={cardyuflyma} alt="card" />
                    ) : category === "vegzelma" ? (
                      <img src={card} alt="card" />
                    ) : category === "zymfentra" ? (
                      <img src={cardzymfentra} alt="card" />
                    ) : category === "adalimumab" ? (
                      <img src={cardadalimumab} alt="card" />
                    ) : category === "steqeyma" ? (
                      <img src={cardsteqeyma} alt="card" />
                    ) : category === "stoboclo" ? (
                      <img src={cardstoboclo} alt="card" />
                    ) : category === "osenvelt" ? (
                      <img src={cardosenvelt} alt="card" />
                    ) : category === "avtozma" ? (
                      <img src={cardavtozma} alt="card" />
                    ) : null}
                    <span className={categoryCardClasses[category] || ""}>
                      {cardID}
                    </span>
                    {/* {category === "zymfentra" && (
                      <>
                        <span className="binZymfentra">{rxBin}</span>
                        <span className="pcnZymfentra">{rxPcn}</span>
                        <span className="groupZymfentra">{rxGroup}</span>
                      </>
                    )} */}
                  </div>
                  <div className="button-holders">
                    <Button
                      className="theme-button theme-button-text secondary-color font-14 fw-medium"
                      type="submit"
                    >
                      INSTRUCTIONS FOR USE
                    </Button>
                  </div>
                </div>
                {isPaySign && (
                  <div className="font-14">
                    <p>
                      Once you have received the primary EOB from the insurance
                      provider, please follow the steps listed below for
                      submitting claims:
                    </p>
                    <p>
                      Please submit the following documents via fax to{" "}
                      <strong>877-431-6444</strong>
                    </p>
                    <ul>
                      <li>
                        Completed claim form (Universal, UB-04 or CMS-1500 Claim
                        Form).
                      </li>
                      <li>
                        Primary Explanation of Benefits (EOB) showing itemized
                        claim from the patient’s private<br></br>
                        insurance company with the cost for each NDC listed
                        separately.
                      </li>
                    </ul>
                    <p>
                      Your office will receive reimbursement of the patient’s
                      applicable co-pay or coinsurance as determined by the
                      Program Terms and Conditions. Please allow 7-10 business
                      days for receipt of payment. Your office will collect
                      patient out-of-pocket responsibility, based on the program
                      benefit design. You are responsible for the collection of
                      the remaining balance from your patient.
                    </p>
                    <p>
                      Please note: You must submit the claim for reimbursement
                      to the Patient Support Program within 180 days of the date
                      listed on the EOB from the patient’s primary insurance
                      company.
                    </p>
                    <div>
                      <Button className="theme-button theme-button-text secondary-color fw-medium instructions-heading-3">
                        PHARMACY CLAIMS PROCESSING:
                      </Button>
                      <p>
                        When you use this card, you are certifying that you have
                        not submitted and will not submit a claim for
                        reimbursement under any federal, state or other
                        governmental programs for this prescription.
                      </p>
                      <ul>
                        <li>
                          Submit transaction to Paysign using{" "}
                          <strong> BIN #610020</strong>
                        </li>
                        <li>
                          If primary commercial prescription insurance exists,
                          input card information as secondary coverage and
                          transmit using the Coordination of Benefits (COB)
                          segment of the National Council for Prescription Drug
                          Programs (NCPDP) transaction. Applicable discounts
                          will be displayed in the transaction response.
                        </li>
                        <li>
                          Acceptance of this card and your submission of claims
                          for the Co-pay Program are subject to the Celltrion
                          CARES<sup>&trade;</sup> Co-pay Assistance Program
                          Terms and Conditions posted at:
                          <a
                            className="instructions-heading-link"
                            target="_blank"
                            href="https://celltrionconnect.com/terms-of-use/"
                            rel="noreferrer"
                          >
                            {" "}
                            celltrionconnect.com/terms-of-use/
                          </a>
                        </li>
                        <li>
                          The Patient is not eligible if prescriptions are paid
                          in part or full by any state or federally funded
                          programs, including but not limited to Medicare or
                          Medicaid, Medigap, VA, DOD or TRICARE and where
                          prohibited by law.
                        </li>
                        <li>
                          The Celltrion CARES<sup>&reg;</sup> Co-pay card is not
                          valid for use with any other prescription drug
                          discount or cash cards. Claims submitted utilizing the
                          program are subject to audit or validation.
                        </li>
                      </ul>
                      <p>
                        For questions regarding setup, claim transmission,
                        patient eligibility or other issues, call the Celltrion
                        CARES
                        <sup className="reg">&reg;</sup> Co-pay Assistance
                        Program at 877-81CONNC (877-812-6662), 8 AM-8 PM ET,
                        Monday - Friday
                      </p>
                    </div>
                  </div>
                )}

                {!isPaySign && (
                  <div className="font-14">
                    <p className="font-16 fw-medium">
                      PHARMACY CLAIMS PROCESSING:
                    </p>
                    <p>
                      When you use this card, you are certifying that you have
                      not submitted and will not submit a claim for
                      reimbursement under any federal, state or other
                      governmental programs for this prescription.
                    </p>
                    <ul>
                      {(category === "zymfentra" ||
                        category === "steqeyma") && (
                        <>
                          <li>
                            Submit transaction to Paysign using{" "}
                            <strong>BIN #610020</strong>
                          </li>
                          <li>
                            If primary commercial prescription insurance exists,
                            input card information as secondary coverage and
                            transmit using the COB segment of the NCPDP
                            transaction. Applicable discounts will be displayed
                            in the transaction response.
                          </li>
                          <li>
                            Acceptance of this card and your submission of
                            claims for the Co-pay Program are subject to the
                            Celltrion CARES
                            <sup>&trade;</sup> Co-pay Assistance Program Terms
                            and Conditions posted at{" "}
                            <a
                              href="https://www.celltrionconnect.com/terms-of-use/"
                              target="_blank"
                              rel="noreferrer"
                            >
                              celltrionconnect.com/terms-of-use/
                            </a>
                          </li>
                        </>
                      )}
                      {category !== "zymfentra" && (
                        <>
                          <li>Submit transaction to BIN #610524</li>
                          <li>
                            If primary commercial prescription insurance exists,
                            input card information as secondary coverage and
                            transmit using the COB segment of the NCPDP
                            transaction. Applicable discounts will be displayed
                            in the transaction response.
                          </li>
                          <li>
                            Acceptance of this card and your submission of
                            claims for the Co-pay Program are subject to the
                            Celltrion CARES<sup>&reg;</sup> Co-pay Assistance
                            Program Terms and Conditions posted at{" "}
                            <a
                              href="https://www.mckesson.com/mprstnc"
                              target="_blank"
                              rel="noreferrer"
                            >
                              www.mckesson.com/mprstnc
                            </a>
                          </li>
                        </>
                      )}
                      <li>
                        The Patient is not eligible if prescriptions are paid in
                        part or full by any state or federally funded programs,
                        including but not limited to Medicare or Medicaid,
                        Medigap, VA, DOD, TRICARE, or where prohibited by law.
                      </li>
                      <li>
                        The Celltrion CARES<sup>&reg;</sup> Co-pay card is not
                        valid for use with any other prescription drug discount
                        or cash cards. Claims submitted utilizing the program
                        are subject to audit or validation.
                      </li>
                    </ul>

                    <p>
                      For questions regarding setup, claim transmission, patient
                      eligibility or other issues, call the Celltrion CARES
                      <sup>&trade;</sup> Co-pay Program at{" "}
                      <span className="fw-medium">
                        1-877-81CONNC (1-877-812-6662)
                      </span>
                      , 8 AM-8 PM ET, Monday - Friday.
                    </p>
                  </div>
                )}
              </div>
            </Col>
          </Row>
          {/* </div> */}
        </Container>
      </section>
    </>
  );
};

export default Pharma;
